import { LiaRupeeSignSolid } from "react-icons/lia";
import { IoEyeOutline } from "react-icons/io5";
import { FaCircle } from "react-icons/fa6";
import { MdModeEdit } from "react-icons/md";
import { FaBriefcase } from "react-icons/fa6";
import { FaPhone } from "react-icons/fa6";
import { FaIdCard } from "react-icons/fa6";
import { FaUserLarge } from "react-icons/fa6";
import { FaTriangleExclamation } from "react-icons/fa6";
import { FaClock } from "react-icons/fa6";
import { RiContactsBook3Fill } from "react-icons/ri";
import { HiIdentification } from "react-icons/hi";
import { FaUserTie } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import { IoSettings } from "react-icons/io5";
import { FaCircleInfo } from "react-icons/fa6";
import { FaLock } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import { FaCloudUploadAlt } from "react-icons/fa";
import { LuRefreshCw } from "react-icons/lu";
import { MdOutlineAccessTimeFilled } from "react-icons/md";
import { FaArrowRotateLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { FaGlobe } from "react-icons/fa6";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiDeleteBinLine } from "react-icons/ri";
import { PiPencilLine } from "react-icons/pi";
import { TbCircleDotted } from "react-icons/tb";
import { BsQuestion } from "react-icons/bs";
import { FaHourglassHalf } from "react-icons/fa6";
import { FaPlug } from "react-icons/fa6";
import { FaCalculator } from "react-icons/fa6";
import { FaBuilding } from "react-icons/fa6";
import { FaUsersGear } from "react-icons/fa6";
import { FaFlask } from "react-icons/fa6";
import { FaLinkSlash } from "react-icons/fa6";
import { FaLink } from "react-icons/fa6";
import { FaFileInvoice } from "react-icons/fa6";
import { FaCog } from "react-icons/fa";
import { FaPlay } from "react-icons/fa6";
import { FaChartLine } from "react-icons/fa6";
import { FaCoins } from "react-icons/fa6";
import { FaBuildingColumns } from "react-icons/fa6";
import { FaUpload } from "react-icons/fa6";
import { FaDownload } from "react-icons/fa6";
import { FaListUl } from "react-icons/fa6";
import { FiPlus } from "react-icons/fi";
import { FaUserTag } from "react-icons/fa6";
import { FaKey } from "react-icons/fa6";
import { FaCircleXmark } from "react-icons/fa6";
import { BsChatDotsFill } from "react-icons/bs";
import { FaFileUpload } from "react-icons/fa";
import { FaFlag } from "react-icons/fa6";
import { FaUserPlus } from "react-icons/fa6";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { FaCircleMinus } from "react-icons/fa6";
import { FaShieldHalved } from "react-icons/fa6";
import { FaRupeeSign } from "react-icons/fa6";
import { FaFileLines } from "react-icons/fa6";
import { FaPaperPlane } from "react-icons/fa6";
import { FaScaleBalanced } from "react-icons/fa6";
import { FaThumbsUp } from "react-icons/fa6";
import { RiFile4Fill } from "react-icons/ri";
import { FaHouse } from "react-icons/fa6";
import { FaPiggyBank } from "react-icons/fa6";
import { FaFilePdf } from "react-icons/fa6";
import { FaHeartPulse } from "react-icons/fa6";
import { FaGraduationCap } from "react-icons/fa6";
import { FaFolder } from "react-icons/fa6";
import { FaHandHoldingHeart } from "react-icons/fa6";
import { FaFileContract } from "react-icons/fa6";
import { GoDotFill } from "react-icons/go";
import { FaBell } from "react-icons/fa6";
import { FaComments } from "react-icons/fa6";
import { FaCakeCandles } from "react-icons/fa6";
import { FaStar } from "react-icons/fa6";
import { FaGifts } from "react-icons/fa6";
import { FaBullhorn } from "react-icons/fa6";
import { FaSquarePollVertical } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa6";
import { FaThumbtack } from "react-icons/fa6";
import { FaFire } from "react-icons/fa6";
import { FaTrophy } from "react-icons/fa6";
import { FaGift } from "react-icons/fa6";
import { FaChartPie } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa6";
import { FaAt } from "react-icons/fa6";
import { FaInbox } from "react-icons/fa6";
import { FaCircleExclamation } from "react-icons/fa6";
import { FaSignature } from "react-icons/fa6";
import { FaArrowUpLong } from "react-icons/fa6";
import { FaFilter } from "react-icons/fa6";
import { FaFileExcel } from "react-icons/fa6";
import { FaFileCsv } from "react-icons/fa6";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaAngleDown } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa6";
import { FaRegImages } from "react-icons/fa6";
import { FaRegImage } from "react-icons/fa6";
import { FaPause } from "react-icons/fa6";
import { FaArrowRotateRight } from "react-icons/fa6";
import { FaPercent } from "react-icons/fa6";
import { FaBars } from "react-icons/fa6";
import { FaFileCircleXmark } from "react-icons/fa6";
import { FaGavel } from "react-icons/fa6";
import { FaBookOpen } from "react-icons/fa6";
import { FaClipboardList } from "react-icons/fa6";
import { FaReceipt } from "react-icons/fa6";
import { FaCommentDots } from "react-icons/fa6";
import { FaFileArrowUp } from "react-icons/fa6"
import { FaCrown } from "react-icons/fa6";
import { FaNoteSticky } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";
import { FaSort } from "react-icons/fa6";
import { FaChartBar } from "react-icons/fa6";


// --------------------------------------
export const ChartBar = ({
  class_name,
  onClick = () => {
    null
  },
}) => {
  return (
    <FaChartBar
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Sort = ({
  class_name,
  onClick = () => {
    null
  },
}) => {
  return (
    <FaSort
      className={class_name}
      onClick={onClick}
    />
  );
};

export const ArrowRightLong = ({
  class_name,
  onClick = () => {
    null
  },
}) => {
  return (
    <FaArrowRightLong
      className={class_name}
      onClick={onClick}
    />
  );
};

export const NoteSticky = ({
  class_name,
  onClick = () => {
    null
  },
}) => {
  return (
    <FaNoteSticky
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Crown = ({
  class_name,
  onClick = () => {
    null
  },
}) => {
  return (
    <FaCrown
      className={class_name}
      onClick={onClick}
    />
  );
};

export const FileArrowUp = ({
  class_name,
  onClick = () => {
    null
  },
}) => {
  return (
    <FaFileArrowUp
      className={class_name}
      onClick={onClick}
    />
  );
};

export const CommentDots = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCommentDots
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Receipt = ({
  class_name,
  onClick = () => {
    null
  },
  color = "yellow",
  fontSize = "25px",
  fontWeight = "600",
  cursor = "pointer",
}) => {
  return (
    <FaReceipt
      className={class_name}
      onClick={onClick}
      style={{ color: color, fontSize, fontWeight, cursor }}
    />
  );
};

export const PencilIcon = ({
  class_name,
  onClick = () => {
    null
  },
  color = "yellow",
  fontSize = "25px",
  fontWeight = "600",
  cursor = "pointer",
}) => {
  return (
    <MdModeEdit
      className={class_name}
      onClick={onClick}
      style={{ color: color, fontSize, fontWeight, cursor }}
    />
  );
};

export const EyeIcon = ({
  class_name,
  onClick = () => {
    null
  },
  fontSize = "20px",
}) => {
  return (
    <IoEyeOutline
      className={class_name}
      onClick={onClick}
      style={{ fontSize }}
    />
  );
};

export const RupeesIcon = ({
  class_name,
  onClick = () => {
    null
  },
  fontSize = "20px",
}) => {
  return (
    <LiaRupeeSignSolid
      className={class_name}
      onClick={onClick}
    // style={{ fontSize }}
    />
  );
};

export const Circle = ({
  class_name,
  onClick = () => {
    null
  },
  color = "#000",
  fontSize = "10px",
  fontWeight = "600",
}) => {
  return (
    <FaCircle
      className={class_name}
      onClick={onClick}
      style={{ color, fontSize, fontWeight }}
    />
  );
};

export const Briefcase = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaBriefcase
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Phone = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaPhone
      className={class_name}
      onClick={onClick}
    />
  );
};

export const IdCard = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaIdCard
      className={class_name}
      onClick={onClick}
    />
  );
};

export const UserLarge = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaUserLarge
      className={class_name}
      onClick={onClick}
    />
  );
};

export const TriangleExclamation = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaTriangleExclamation
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Clock = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaClock
      className={class_name}
      onClick={onClick}
    />
  );
};

export const ContactsBook3Fill = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <RiContactsBook3Fill
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Identification = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <HiIdentification
      className={class_name}
      onClick={onClick}
    />
  );
};

export const UserTie = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaUserTie
      className={class_name}
      onClick={onClick}
    />
  );
};

export const CircleCheck = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCircleCheck
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Settings = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <IoSettings
      className={class_name}
      onClick={onClick}
    />
  );
};

export const CircleInfo = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCircleInfo
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Lock = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaLock
      className={class_name}
      onClick={onClick}
    />
  );
};

export const CalendarAlt = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCalendarAlt
      className={class_name}
      onClick={onClick}
    />
  );
};

export const CloudUploadAlt = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCloudUploadAlt
      className={class_name}
      onClick={onClick}
    />
  );
};

export const RefreshCw = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <LuRefreshCw
      className={class_name}
      onClick={onClick}
    />
  );
};

export const OutlineAccessTimeFilled = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <MdOutlineAccessTimeFilled
      className={class_name}
      onClick={onClick}
    />
  );
};

export const ArrowRotateLeft = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaArrowRotateLeft
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Save = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaSave
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Check = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCheck
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Download = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaDownload
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Cross = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaTimes
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Users = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaUsers
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Globe = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaGlobe
      className={class_name}
      onClick={onClick}
    />
  );
};

export const FileCircleExclamation = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFileCircleExclamation
      className={class_name}
      onClick={onClick}
    />
  );
};

export const DeleteBinLine = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <RiDeleteBinLine
      className={class_name}
      onClick={onClick}
    />
  );
};

export const PencilLine = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <PiPencilLine
      className={class_name}
      onClick={onClick}
    />
  );
};

export const CircleDotted = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <TbCircleDotted
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Question = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <BsQuestion
      className={class_name}
      onClick={onClick}
    />
  );
};

export const HourglassHalf = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaHourglassHalf
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Plug = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaPlug
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Calculator = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCalculator
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Building = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaBuilding
      className={class_name}
      onClick={onClick}
    />
  );
};

export const UsersGear = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaUsersGear
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Flask = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFlask
      className={class_name}
      onClick={onClick}
    />
  );
};

export const LinkSlash = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaLinkSlash
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Link = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaLink
      className={class_name}
      onClick={onClick}
    />
  );
};

export const FileInvoice = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFileInvoice
      className={class_name}
      onClick={onClick}
    />
  );
};

export const SettingCog = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCog
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Play = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaPlay
      className={class_name}
      onClick={onClick}
    />
  );
};

export const ChartLine = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaChartLine
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Coins = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCoins
      className={class_name}
      onClick={onClick}
    />
  );
};

export const BuildingColumns = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaBuildingColumns
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Upload = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaUpload
      className={class_name}
      onClick={onClick}
    />
  );
};

export const ListUl = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaListUl
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Plus = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FiPlus
      className={class_name}
      onClick={onClick}
    />
  );
};

export const UserTag = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaUserTag
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Key = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaKey
      className={class_name}
      onClick={onClick}
    />
  );
};

export const CircleXmark = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCircleXmark
      className={class_name}
      onClick={onClick}
    />
  );
};

export const ChatDotsFill = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <BsChatDotsFill
      className={class_name}
      onClick={onClick}
    />
  );
};

export const FileUpload = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFileUpload
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Flag = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFlag
      className={class_name}
      onClick={onClick}
    />
  );
};

export const UserPlus = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaUserPlus
      className={class_name}
      onClick={onClick}
    />
  );
};

export const Search = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaMagnifyingGlass
      className={class_name}
      onClick={onClick}
    />
  );
};

export const CircleMinus = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCircleMinus
      className={class_name}
      onClick={onClick}
    />
  );
};

export const ShieldHalved = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaShieldHalved
      className={class_name}
      onClick={onClick}
    />
  );
};

export const RupeeSign = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaRupeeSign
      className={class_name}
      onClick={onClick}
    />
  );
};

export const FileLines = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFileLines
      className={class_name}
      onClick={onClick}
    />
  );
};

export const PaperPlane = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaPaperPlane
      className={class_name}
      onClick={onClick}
    />
  );
};

export const ScaleBalanced = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaScaleBalanced
      className={class_name}
      onClick={onClick}
    />
  );
};

export const ThumbsUp = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaThumbsUp
      className={class_name}
      onClick={onClick}
    />
  );
};

export const File4Fill = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <RiFile4Fill
      className={class_name}
      onClick={onClick}
    />
  );
};

export const House = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaHouse
      className={class_name}
      onClick={onClick}
    />
  );
};

export const PiggyBank = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaPiggyBank
      className={class_name}
      onClick={onClick}
    />
  );
};

export const FilePdf = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFilePdf
      className={class_name}
      onClick={onClick}
    />
  );
};

export const HeartPulse = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaHeartPulse
      className={class_name}
      onClick={onClick}
    />
  );
};

export const GraduationCap = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaGraduationCap
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Folder = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFolder
      className={class_name}
      onClick={onClick}
    />
  );
}

export const HandHoldingHeart = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaHandHoldingHeart
      className={class_name}
      onClick={onClick}
    />
  );
}

export const FileContract = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFileContract
      className={class_name}
      onClick={onClick}
    />
  );
}

export const DotFill = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <GoDotFill
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Bell = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaBell
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Comments = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaComments
      className={class_name}
      onClick={onClick}
    />
  );
}

export const CakeCandles = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCakeCandles
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Star = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaStar
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Gifts = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaGifts
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Horn = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaBullhorn
      className={class_name}
      onClick={onClick}
    />
  );
}

export const PollVertical = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaSquarePollVertical
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Envelope = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaEnvelope
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Pinned = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaThumbtack
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Fire = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFire
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Trophy = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaTrophy
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Gift = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaGift
      className={class_name}
      onClick={onClick}
    />
  );
}

export const ChartPie = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaChartPie
      className={class_name}
      onClick={onClick}
    />
  );
}

export const LocationDot = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaLocationDot
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Heart = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaHeart
      className={class_name}
      onClick={onClick}
    />
  );
}

export const At = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaAt
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Inbox = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaInbox
      className={class_name}
      onClick={onClick}
    />
  );
}

export const CircleExclamation = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaCircleExclamation
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Signature = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaSignature
      className={class_name}
      onClick={onClick}
    />
  );
}

export const ArrowUpLong = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaArrowUpLong
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Filter = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFilter
      className={class_name}
      onClick={onClick}
    />
  );
}

export const FileExcel = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFileExcel
      className={class_name}
      onClick={onClick}
    />
  );
}

export const FileCsv = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFileCsv
      className={class_name}
      onClick={onClick}
    />
  );
}

export const ArrowLeftLong = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaArrowLeftLong
      className={class_name}
      onClick={onClick}
    />
  );
}

export const AngleDown = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaAngleDown
      className={class_name}
      onClick={onClick}
    />
  );
}

export const AngleUp = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaAngleUp
      className={class_name}
      onClick={onClick}
    />
  );
}

export const DummyIcon = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaRegImages
      className={class_name}
      onClick={onClick}
    />
  );
}

export const DummyImage = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaRegImage
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Pause = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaPause
      className={class_name}
      onClick={onClick}
    />
  );
}

export const ArrowRotateRight = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaArrowRotateRight
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Percent = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaPercent
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Bars = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaBars
      className={class_name}
      onClick={onClick}
    />
  );
}

export const FileCircleXmark = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaFileCircleXmark
      className={class_name}
      onClick={onClick}
    />
  );
}

export const Hammer = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaGavel
      className={class_name}
      onClick={onClick}
    />
  );
}

export const BookOpen = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaBookOpen
      className={class_name}
      onClick={onClick}
    />
  );
}

export const ClipboardList = ({
  class_name,
  onClick = () => {
    null
  }
}) => {
  return (
    <FaClipboardList
      className={class_name}
      onClick={onClick}
    />
  );
}


// export {
//   ClipboardList,
//   BookOpen,
//   Hammer,
//   FileCircleXmark,
//   PencilIcon,
//   RupeesIcon,
//   EyeIcon,
//   Circle,
//   Briefcase,
//   Phone,
//   IdCard,
//   UserLarge,
//   TriangleExclamation,
//   Clock,
//   ContactsBook3Fill,
//   Identification,
//   UserTie,
//   CircleCheck,
//   Settings,
//   CircleInfo,
//   Lock,
//   CalendarAlt,
//   CloudUploadAlt,
//   RefreshCw,
//   OutlineAccessTimeFilled,
//   ArrowRotateLeft,
//   Save,
//   Check,
//   Download,
//   Cross,
//   Users,
//   Globe,
//   FileCircleExclamation,
//   DeleteBinLine,
//   PencilLine,
//   CircleDotted,
//   Question,
//   HourglassHalf,
//   Plug,
//   Calculator,
//   Building,
//   UsersGear,
//   Flask,
//   LinkSlash,
//   Link,
//   FileInvoice,
//   SettingCog,
//   Play,
//   ChartLine,
//   Coins,
//   BuildingColumns,
//   Upload,
//   ListUl,
//   Plus,
//   UserTag,
//   Key,
//   CircleXmark,
//   ChatDotsFill,
//   FileUpload,
//   Flag,
//   UserPlus,
//   Search,
//   CircleMinus,
//   ShieldHalved,
//   RupeeSign,
//   FileLines,
//   PaperPlane,
//   ScaleBalanced,
//   ThumbsUp,
//   File4Fill,
//   House,
//   PiggyBank,
//   FilePdf,
//   HeartPulse,
//   GraduationCap,
//   Folder,
//   HandHoldingHeart,
//   FileContract,
//   DotFill,
//   Bell,
//   Comments,
//   CakeCandles,
//   Star,
//   Gifts,
//   Horn,
//   PollVertical,
//   Envelope,
//   Pinned,
//   Fire,
//   Trophy,
//   Gift,
//   ChartPie,
//   LocationDot,
//   Heart,
//   At,
//   Inbox,
//   CircleExclamation,
//   Signature,
//   ArrowUpLong,
//   Filter,
//   FileExcel,
//   FileCsv,
//   ArrowLeftLong,
//   AngleDown,
//   AngleUp,
//   DummyIcon,
//   DummyImage,
//   Pause,
//   ArrowRotateRight,
//   Percent,
//   Bars
// };


/*


address
: 
"raipur chhattisgarh"
emergencyContactName
: 
"Somesh"
emergencyContactNumber
: 
"1230009000"
emergencyContactRelation
: 
"F


*/
